import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  codebookList: [],
  codebookChildrenList: [],
  parentCodebookList: [],
  codebook: null,
  loading: false,
  loadingChildren: false,
  error: undefined,
  totalElements: '',
  totalElementsChildren: '',
  codebooksForCombo: {},
};

const codeCodebookSlice = createSlice({
  name: 'codeCodebook',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    stopLoading(state) {
      state.loading = false;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    addCodebook(state, action) {
      state.codebookList = [action.payload].concat(state.codebookList);
      state.error = undefined;
      state.loading = false;
    },
    activateCodebook(state, action) {
      state.codebookList = state.codebookList.map((codebook) =>
        codebook.id === action.payload.id ? action.payload : codebook
      );
      state.error = undefined;
      state.loading = false;
    },
    deactivateCodebook(state, action) {
      state.codebookList = state.codebookList.map((codebook) =>
        codebook.id === action.payload.id ? action.payload : codebook
      );
      state.error = undefined;
      state.loading = false;
    },
    updateCodebook(state, action) {
      state.codebookList = state.codebookList.map((codebook) =>
        codebook.id === action.payload.id ? action.payload : codebook
      );
      state.error = undefined;
      state.loading = false;
    },
    deleteCodebook(state, action) {
      state.codebookList = state.codebookList.filter(
        (codebook) => codebook.id !== action.payload
      );
      state.error = undefined;
      state.loading = false;
    },
    setCodebook(state, action) {
      state.codebook = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    setCodebooksForCombo(state, action) {
      state.codebooksForCombo = {
        ...state.codebooksForCombo,
        ...action.payload,
      };
      state.error = undefined;
      state.loading = false;
    },
    setParentCodebookList(state, action) {
      state.parentCodebookList = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    clearParentCodebookList(state) {
      state.parentCodebookList = [];
      state.loading = false;
      state.error = undefined;
    },
    clearCodebooksForCombo(state) {
      state.codebooksForCombo = {};
      state.error = undefined;
      state.loading = false;
    },
    clearCodeCodebook(state) {
      state.codebook = {};
      state.error = undefined;
      state.loading = false;
    },
    clearCodeCodebookList(state) {
      state.codebookList = [];
      state.error = undefined;
      state.loading = false;
    },
  },
});

export const codeCodebookActions = codeCodebookSlice.actions;

export default codeCodebookSlice.reducer;
